import { Dispatch, SetStateAction, useEffect, useState } from "react";
import moment from "moment";
import { Button, ListItem } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import DrawerApp from "../../components/Drawer/DrawerApp";
import SelectSimple from "../../components/Selects/SelectSimple";
import InputLabel from "../../components/Inputs/InputLabel";
import { SnackMessageProps } from "../../components/SnackBar/SnackBar";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api } from "../../services/api";
import { Advs, consultProcessosDJEN } from "./ConsutlProcessosDJEN";

type NewConsultProps = {
    open: boolean
    setOpen: Dispatch<SetStateAction<boolean>>
    restResults: Dispatch<SetStateAction<any>>
    setSnack: Dispatch<SetStateAction<SnackMessageProps>>
}

export default function NewConsult({ open, setOpen, restResults, setSnack }: NewConsultProps) {
    const [busca, setBusca] = useState<string | number>("1");
    const [dataInicial, setDataInicial] = useState(moment().format("YYYY-MM-DD"));
    const [dataFinal, setDataFinal] = useState(moment().format("YYYY-MM-DD"));
    const [protocolo_processo, setProtocoloProcesso] = useState("");
    const [id_advogado_processo, setIdAdvogadoCausa] = useState<string | number>("0");
    const [arrAdvogados, setArrAdvogados] = useState<Advs[]>([{ value: "0", label: "TODOS" }]);
    const [load, setLoad] = useState(false);

    

    async function handleSearch() {
        if (busca === '1') {
            if (!moment(dataInicial).isValid()) return setSnack({ open: true, text: 'Data Inicial Invalida', color: 'error' });
            if (!moment(dataFinal).isValid()) return setSnack({ open: true, text: 'Data Final Invalida', color: 'error' });
        } else if (busca === '2' && protocolo_processo.trim() === '') {
            return setSnack({ open: true, text: 'Preencha o Numero do Processo', color: 'error' })
        }
        setLoad(true);
        try {
            const advogados = id_advogado_processo === '0' ? arrAdvogados.filter(a => Number(a.value) > 0) : arrAdvogados.filter(a => Number(a.value) === Number(id_advogado_processo));
            const dataBusca = { busca, dataInicial, dataFinal, protocolo_processo, advogados };
            // const response = await api.post(`/consultapje`, dataBusca);
            const response = await consultProcessosDJEN(dataBusca);
            console.log(response);
            if (response.error) {
                setOpen(false);
                AlertInfo({ icon: 'error', title: response.msg });
            } else if (response) {
                restResults(response);
                setOpen(false);
                setSnack({ open: true, text: `${response.length} Resultados Encontrados`, color: 'success' });
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setLoad(false);
    }

    async function loadData() {
        try {
            const response = await api.get(`/optionsprocesso`);
            if (response && response.status === 200 && response.data) {
                if (!response.data.error) {
                    if (response.data.advogados) {
                        const optAdv = response.data.advogados;
                        setArrAdvogados([
                            { value: "0", label: "TODOS" },
                            ...optAdv.map((c: any) => ({ ...c, value: c.id_usuario, label: c.nome_usuario }))
                        ]);
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <DrawerApp
            open={open}
            setOpen={setOpen}
            title="CONSULTAR PROCESSOS"
        >
            <>
                <SimpleBackdrop
                    open={load}
                    zIndex={9999}
                />

                <ListItem>
                    <SelectSimple
                        label="Busca"
                        value={busca}
                        setState={setBusca}
                        options={[
                            { value: "1", label: "PERIODO" },
                            { value: "2", label: "PROTOCOLO PROCESSO" }
                        ]}
                    />
                </ListItem>

                {busca == "1" && (
                    <>
                        <ListItem>
                            <InputLabel
                                label="Data Inicio"
                                type="date"
                                value={dataInicial}
                                setState={setDataInicial}
                            />
                        </ListItem>
                        <ListItem>
                            <InputLabel
                                label="Data Fim"
                                type="date"
                                value={dataFinal}
                                setState={setDataFinal}
                            />
                        </ListItem>
                        <ListItem>
                            <SelectSimple
                                id="id_advogado_processo"
                                label="Advogado(a)"
                                value={id_advogado_processo}
                                setState={setIdAdvogadoCausa}
                                options={arrAdvogados}
                            />
                        </ListItem>
                    </>
                )}

                {busca === "2" && (
                    <ListItem>
                        <InputLabel
                            label="Numero do Processo"
                            value={protocolo_processo}
                            setState={setProtocoloProcesso}
                        />
                    </ListItem>
                )}

                <ListItem>
                    <Button
                        variant="contained"
                        fullWidth
                        startIcon={<SearchIcon />}
                        onClick={handleSearch}
                    >
                        BUSCAR
                    </Button>
                </ListItem>
            </>
        </DrawerApp>
    );
}